export default {
  name: 'AudioJungle',
  abbreviation: 'AJ',
  domain: 'audiojungle.net',
  google_analytics_id: 'UA-11834194-4',
  google_remarketing_label: 'SQ7NCLWBugMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. ambient music',
  search_query: {
    default_sort_by: 'date'
  },
  features: {
    /**
     * @description Is true, we collapse the tags filter for all category pages unless it's a bottom level category (no children)
     * @author Geoff Evason
     * @expires Never.  This is currently used by some markets and not others.
     */
    'collapse-tags-unless-bottom-category': true
  }
}
